import {processGetManyFilter, processGetManyByReferenceFilter, processFilters, addSortToUrl, readJsonOrRefuse, refuseOnHttpError} from "./provider/defaults";
import {
    CreateParams, CreateResult,
    DataProvider,
    DeleteManyParams,
    DeleteParams, DeleteResult,
    GetListParams, GetListResult,
    GetManyParams,
    GetManyReferenceParams, GetManyReferenceResult, GetManyResult,
    GetOneParams, GetOneResult,
    UpdateManyParams, UpdateManyResult,
    UpdateParams, UpdateResult
} from "react-admin";
import { read_cookie, delete_cookie } from 'sfcookies';
import { useGetBrainApi } from "../utils/UrlManager"
import { hostUrl, UseUrlManagerCleanUrl, apiUrl } from "../components/utils/url-manager";
import { addUrlToUri, removeUrlFromUri, restoreEntityString, cleanEntityString, convertFileToBase64 } from "./provider/defaults";
import { Tool } from "../types/entities";


function cleanParams(tool: any): Tool {
    let image = undefined;
    if (tool['image'] !== undefined) {
        image = {
            src: hostUrl + tool['image'],
            title: tool['name']
        }
    }

    let customParams = tool['customerParameters'];
    try {
        // let f
    } catch (error) {
        // Do nothing
    }

    return {
        id: tool['id'],
        operatorToolId: tool['operatorToolId'],
        description: tool['description'],
        customParameters: tool['customParameters'],
        name: tool['name'],
        image: image,
        enabled: tool['enabled']
    }
}

const adminAiSystemAgentToolsProvider: DataProvider = {

    getList: async (resource: string, params: GetListParams) : Promise<GetListResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource;
        if (params.pagination) {
            url += '?page=' + params.pagination.page + '&itemsPerPage=' + params.pagination.perPage;
        }
        url = processFilters(url, params);
        url = addSortToUrl(url, params);
        url = UseUrlManagerCleanUrl({ url: url });
        const request: Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then( (data: any) => {
                console.log(data);
                let responseData: { data: Tool[], total: number } = {
                    data: [],
                    total: 0
                };
                if (Array.isArray(data['hydra:member'])) {
                    let tools: any[] = data['hydra:member'];
                    let totalItems: number = data['hydra:totalItems'];

                    for(let i: number = 0; i < tools.length; i++) {
                        let tool: any[] = tools[i];
                        responseData.data.push(cleanParams(tool))
                    }
                    responseData.total = totalItems;
                }
                return responseData;
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error)
            });
    },
    // get a single record by id
    getOne: async (resource: string, params: GetOneParams) : Promise<GetOneResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource + '/' + params.id;
        url = UseUrlManagerCleanUrl({ url: url })
        const request: Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then(data => {
                console.log(data);
                let responseData: { data: Tool|null } = {
                    data: null
                };
                if (data['id']) {
                    responseData.data = cleanParams(data)
                }
                return responseData;
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error);
            });
    },
    // get a list of records based on an array of ids
    getMany: async (resource: string, params: GetManyParams) : Promise<GetManyResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource;
        url = processGetManyFilter(url, params);
        url = addSortToUrl(url, params);
        url = UseUrlManagerCleanUrl({ url: url })
        const request: Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then( (data: any) => {
                let responseData: { data: Tool[], total: number } = {
                    data: [],
                    total: 0
                };
                if (Array.isArray(data['hydra:member'])) {
                    let tools: any[] = data['hydra:member'];
                    let totalItems: number = data['hydra:totalItems'];
                    //debugger;
                    for(let i: number = 0; i < tools.length; i++) {
                        let tool: any[] = tools[i];
                        responseData.data.push(cleanParams(tool))
                    }
                    responseData.total = totalItems;
                }
                return responseData;
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error)
            });
    },
    // get the records referenced to another record, e.g. comments for a post
    getManyReference: async (resource: string, params: GetManyReferenceParams) : Promise<GetManyReferenceResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource;
        if (params.pagination) {
            url += '?page=' + params.pagination.page + '&itemsPerPage=' + params.pagination.perPage;
        }
        url = processGetManyByReferenceFilter(url, params);
        url = addSortToUrl(url, params);
        url = UseUrlManagerCleanUrl({ url: url })
        const request: Request = new Request(url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then(data => {
                let responseData: { data: Tool[], total: number } = {
                    data: [],
                    total: 0
                };
                if (Array.isArray(data['hydra:member'])) {
                    let tools: any[] = data['hydra:member'];
                    let totalItems: number = data['hydra:totalItems'];
                    //debugger;
                    for(let i: number = 0; i < tools.length; i++) {
                        let tool: any[] = tools[i];
                        responseData.data.push(cleanParams(tool))
                    }
                    responseData.total = totalItems;
                }
                return responseData;
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error);
            });
    },
    // create a record
    create: async (resource: string, params: CreateParams) : Promise<CreateResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource;
        if (params.data.image !== null) {
            if (params.data.image.src.includes(hostUrl)) {
                params.data.image = params.data.image.src.replace(hostUrl, '');
            } else {
                params.data.image.src = params.data.image.src.replace(hostUrl, '');
                const image = await convertFileToBase64(params.data.image);
                params.data.file_name = params.data.image.title;
                params.data.image = image ?? '';
            }

        } else {
            params.data.image = null;
        }
        if (params.data.customParameters !== undefined) {
            try {
                let customParams = JSON.parse(params.data.customParameters);
                params.data.customParameters = JSON.stringify(customParams, undefined, 4);
            } catch (error) {
                // Do nothing as won't format to JSON
            }

        }
        url = UseUrlManagerCleanUrl({ url: url })
        const request: Request = new Request(url, {
            method: 'POST',
            body: JSON.stringify(params['data']),
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then( (data: any) => {
                console.log(data);
                let responseData: { data: Tool|null } = {
                    data: null
                };
                if (data['id']) {
                    responseData.data = cleanParams(data)
                }
                return responseData;
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error);
            });

    },
    // update a record based on a patch
    update: async (resource: string, params: UpdateParams) : Promise<UpdateResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource + '/' + params.data.id;
        if (params.data.image !== null) {
            if (params.data.image.src.includes(hostUrl)) {
                params.data.image = params.data.image.src.replace(hostUrl, '');
            } else {
                params.data.image.src = params.data.image.src.replace(hostUrl, '');
                const image = await convertFileToBase64(params.data.image);
                params.data.file_name = params.data.image.title;
                params.data.image = image ?? '';
            }

        } else {
            params.data.image = null;
        }

        if (params.data.customParameters !== undefined) {
            try {
                let customParams = JSON.parse(params.data.customParameters);
                params.data.customParameters = JSON.stringify(customParams, undefined, 4);
            } catch (error) {
                // Do nothing as won't format to JSON
            }

        }

        url = UseUrlManagerCleanUrl({ url: url })
        const request: Request = new Request(url, {
            method: 'PATCH',
            body: JSON.stringify(params['data']),
            headers: new Headers({
                'Content-Type' : 'application/merge-patch+json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return readJsonOrRefuse(response);
            })
            .then(data => {
                let responseData: { data: Tool|null } = {
                    data: null
                };
                if (data['id']) {
                    responseData.data = cleanParams(data)
                }
                return responseData;
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error);
            });
    },
    // update a list of records based on an array of ids and a common patch
    updateMany: async (resource: string, params: UpdateManyParams) : Promise<UpdateManyResult> => {
        return Promise.reject();
    },
    // delete a record by id
    delete: async (resource: string, params: DeleteParams) : Promise<DeleteResult> => {
        let token: string = read_cookie('auth');
        let url: string = apiUrl + resource + '/' + params.id;
        url = UseUrlManagerCleanUrl({ url: url })
        const request: Request = new Request(url, {
            method: 'DELETE',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token' : token,
                'hq': 'hq'
            })
        });
        return fetch(request)
            .then( (response: Response) => {
                return refuseOnHttpError(response)
                    .then((): { data: any } => ({ data: params }));
            })
            .catch( (error: Error) => {
                console.log(error);
                return Promise.reject(error);
            });
    },
    // delete a list of records based on an array of ids
    deleteMany: async (resource: string, params: DeleteManyParams) : Promise<any> => {
        return Promise.reject();
    },
    getProfileData: (params) => {
        return Promise.resolve();
    }
}

export default adminAiSystemAgentToolsProvider;